<template>
    <div class="container">
        <div class="seacher">
            <el-form :inline="true" class="demo-form-inline"   label-width="80px"  size="small">
                <el-form-item label="开始日期" prop="beginTime">
                    <el-date-picker  clearable v-model="queryParams.beginTime" style="width:215px"
                        type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
                        >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="endTime">
                    <el-date-picker  clearable v-model="queryParams.endTime" style="width:215px"
                        type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期" >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="发票号" prop="radio">
                    <el-input clearable v-model.trim="queryParams.voucherNo" placeholder="请输入发票号"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input clearable v-model="queryParams.note" placeholder="请输入备注"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="往来单位">
                    <el-select filterable clearable v-model="queryParams.company"
                        placeholder="请选择往来单位">
                        <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                    <!-- <el-input clearable v-model.trim="queryParams.customer" placeholder="请输入委托单位"
                            style="width: 100%;"></el-input> -->
                </el-form-item>
                 <el-form-item label="申请单号">
                    <el-input size="small" clearable v-model.trim="queryParams.billNo" placeholder="请输入申请单号"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="申请人">
                    <el-select size="small" filterable clearable v-model="queryParams.applyMan"
                        placeholder="请选择申请人">
                        <el-option v-for="item in applyManList" :key="item.id" :label="item.userName"
                            :value="item.userName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款状态">
                    <el-checkbox style="width:215px" v-model="paidStatusCheck">未付款</el-checkbox>
                </el-form-item>
                <el-form-item label="审核状态">
                    <el-radio-group v-model="queryParams.checkStatus" @input="approveState">
                        <el-radio label="0">新建</el-radio>
                        <el-radio label="1">审核中</el-radio>
                        <el-radio label="2">审核完成</el-radio>
                        <el-radio label="3">审核驳回</el-radio>
                        <el-radio label="9">待我审核</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div style="min-width: 220px;">
                <el-button type="primary" @click="submit" style="flex-wrap: nowrap; " size="small">查询</el-button>
                <el-button type="success" @click="add" style="flex-wrap: nowrap; " size="small">添加</el-button>
                <el-button type="warning" @click="exportExcel" style="flex-wrap: nowrap; " size="small">导出excel</el-button>
            </div>
        </div>
        <div class="main_height">
            <!-- <el-table :data="list.filter(data => !searchText || data.blNos.toLowerCase().includes(searchText.toLowerCase()) )"  -->
            <el-table :data="searchList()" 
                :cell-style="rowStyle" id="tableId" ref="tableId" height="100%"
                style=" margin-top: 0px;" :summary-method="getSummaries" :show-summary="list.length === 0 ? false: true" border  >
                <el-table-column label="序号" type="index" width="50" align="center">
                </el-table-column>
                <af-table-column label="单据编号" align="center" prop="billNo" width="120">
                    <template slot-scope="scope">
                        <!-- <i class="iconfont icon-bianmubianma"></i> -->
                        <span @click="handleClick(scope.row)" :class="{ hoverStyle: true }"
                            style="cursor: pointer">{{ scope.row.billNo }}</span>
                    </template>
                </af-table-column>
                <!-- <af-table-column label="银行" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.bank }}</span>
                    </template>
                </af-table-column> -->
                <el-table-column label="提单号" align="center" prop="blNos" width="160">
                    <template slot-scope="scope">
                            <div class="ellipsis" @click="blNosAll(scope.row.blNos)">{{ scope.row.blNos }}</div>
                    </template>
                </el-table-column>
                <af-table-column label="分单号" align="center" prop="subNos" width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.subNos === "null"? '':scope.row.subNos }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="往来单位" align="center" prop="company" width="220">
                    <template slot-scope="scope">
                        <span>{{ scope.row.company }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="发票号" align="center" prop="voucherNo" width="120"> 
                    <template slot-scope="scope">
                        <span>{{ scope.row.voucherNo }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="金额" align="center" prop="amount" width="120px">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.amount }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="币制" align="center" prop="currency"  width="80px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.currency }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="审核状态" align="center" prop="checkStatus" width="80">
                    <template slot-scope="scope">
                        <span><el-link type="primary" @click="getCommentText(scope.row)">{{ getCheckStatusText(scope.row.checkStatus) }}</el-link></span>
                    </template>
                </af-table-column>
                <af-table-column label="付款状态" align="center" prop="financeStatus" width="80">
                    <template slot-scope="scope">
                            <span v-if="scope.row.financeStatus === '已付款'"><el-tag  type="success">{{ scope.row.financeStatus }}</el-tag></span>
                            <span v-else>{{ scope.row.financeStatus }}</span>
                        </template>
                </af-table-column>
                <!-- <af-table-column label="订单状态" align="center" prop="receiptStatus" width="80">
                    <template slot-scope="scope">
                            <span v-if="scope.row.receiptStatus === '已付款'"><el-tag  type="success">{{ scope.row.receiptStatus }}</el-tag></span>
                            <span v-else>{{ scope.row.receiptStatus }}</span>
                        </template>
                </af-table-column> -->
                <af-table-column label="创建人" align="center" prop="createMan" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.createMan }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="创建时间" align="center" width="140" prop="createTime" >
                    <template slot-scope="scope">
                        <span>{{ scope.row.createTime }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="提交时间" align="center" width="140" prop="processTime" >
                    <template slot-scope="scope">
                        <span>{{ scope.row.processTime }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="备注" align="center" prop="note" width="270">
                    <template slot-scope="scope">
                        <span>{{ scope.row.note }}</span>
                    </template>
                </af-table-column>
                <!-- <el-table-column label="操作" align="center" width="193" fixed="right" > -->
                <el-table-column  align="center" width="193" fixed="right" >
                    <template slot="header" slot-scope="scope">
                        <el-input v-model="searchText"  size="mini" placeholder="输入提单号、金额搜索"/>
                    </template>
                    <template slot-scope="scope" >
                        <!-- <el-button round size="small" icon="el-icon-edit" type="warning"
                            @click="amendRow(scope.row)">修改</el-button> -->
                        <el-button plain size="mini" type="primary" v-if="queryParams.checkStatus == '0' || queryParams.checkStatus == '3'"
                            @click="approvalShow(scope.row)">发起审批</el-button>
                        <el-button plain size="mini" type="success" v-if="queryParams.checkStatus == '9'"
                            @click="approvalPass(scope.row)">审批</el-button>
                        <el-button plain size="mini" type="danger" v-if="queryParams.checkStatus == '0'"
                            @click="deleteRow(scope.row)">删除</el-button>
                        <el-button plain size="mini" type="primary" v-if="queryParams.checkStatus == '2'"
                            @click="financeFiles(scope.row)">付款登记</el-button>
                        <el-button plain size="mini" type="primary" v-if="queryParams.checkStatus == '1'"
                            @click="withdraw(scope.row)">撤回</el-button>
                        <el-button plain size="mini" type="danger" v-if="queryParams.checkStatus == '2' && scope.row.financeStatus !== '已付款'&& rolePermission === '领导'"
                            @click="withdrawNew(scope.row)">一键撤回</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div  style="background-color: white;height: 63px;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 50, 100,1000]" :page-size="10" style="padding: 10px;"
                layout="sizes, prev, pager, next" :total="total">
            </el-pagination>
        </div>
        <addFund ref="addFund" :busId="id"></addFund>
        <!-- 发起审批弹出框 -->
        <el-dialog title="发起审批" :visible.sync="approvalDialog" width="40%" :before-close="cancelApproval">
            <el-form :model="approvalFrom" label-width="85px" :rules="approvalRules" ref="approvalFrom" >
                <el-form-item label="财务单据">
                    <el-input v-model="approvalFrom.voucherName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="业务主管" prop="manager">
                    <div>{{ approvalFrom.manager }}</div>
                    <!-- <el-select size="small" style="width: 100%;" v-model="approvalFrom.manager" placeholder="请选择客户经理">
                        <template v-for="(item,index) in staffOption">
                            <el-option :label="item.userName" :value="item.userName"></el-option>
                        </template>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="流程名称" prop="flowKey">
                    <el-select size="small" style="width: 100%;" v-model="approvalFrom.flowKey" placeholder="请选择审批流程" @change="changeFlowKey">
                        <template v-for="(item,index) in flowableList">
                            <el-option :label="item.name" :value="item.keyName"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    {{ approvalFrom.description }}
                </el-form-item>
                <el-form-item label="上传附件" prop="file">
                    <el-upload class="upload-demo" :action="saveOneAttachmentURL" :file-list="approvalFrom.file" multiple :auto-upload="false"
                    :on-change="handleChange" :on-remove="handleRemove" >
                    <el-button size="small" type="primary">选择文件</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="已上传附件" v-if="uploadFilesList.length">
                    <div class="upload-list">
                            <span v-for="item in uploadFilesList" :key="item.id">
                                <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.annexName }}</el-link>
                            </span>
                        </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelApproval">取 消</el-button>
                <el-button type="primary" @click="submitApproval">提交审批</el-button>
            </span>
        </el-dialog>
        <!-- 审批意见弹出框 -->
        <el-dialog title="审批意见" :visible.sync="opinionDialog" width="60%" :before-close="closeOpinion">
            <span v-for="item in opinionText" >
                <div style="margin-bottom: 10px;margin-right: 10px;">{{item}}</div>
            </span>
            <!-- 步骤条  -->
             <el-steps v-if="stepBar.processInstanceId && opinionDialog" :active="stepBar.activeNodes?stepBar.completedNodes.length + 1:stepBar.completedNodes.length + 2" finish-status="success">
                <el-step title="发起审批" description=""> 
                    <template slot="description" >
                        流程名称：{{ stepBar.processDefinitionName }}<br/>
                        发起人：{{ stepBar.createMan }}<br/>
                        发起时间：{{ stepBar.startTime }}
                    </template>
                </el-step>
                <el-step v-for="item,index in stepBar.allNodes" :title="item.nodeName" >
                    <template slot="description" >
                        <span>
                            审批人：{{item.assigneeId}}<br/>
                        </span>
                        <span v-if="index+1 <= stepBar.completedNodes.length">
                            开始审批：{{item.startTime}}<br/>
                            结束审批：{{item.endTime}}<br/>
                            审批耗时：{{item.duration}}
                        </span>
                    </template>
                </el-step>
                <el-step title="结束审批" description=""> </el-step>
            </el-steps>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeOpinion">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 审批意见填写 -->
        <el-dialog title="审批意见" :visible.sync="opinionFillDialog" width="40%" :before-close="cancelapprove">
            <el-input v-model="opinionFill.comment" placeholder="请输入审批意见"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="agree">同意</el-button>
                <el-button type="primary" @click="reject">驳回</el-button>
                <el-button type="primary" @click="cancelapprove">取消</el-button>
            </span>
        </el-dialog>
        <!-- 财务上传附件弹窗 -->
        <el-dialog title="付款登记" :visible.sync="financeDialog" width="40%" :before-close="cancelfFnance">
            <el-form :model="financeFrom" label-width="80px" :rules="financeRules" ref="financeFrom" >
                <el-form-item label="上传附件" prop="file">
                    <el-upload class="upload-demo" :action="saveOneAttachmentURL" :file-list="financeFrom.file" multiple :auto-upload="false"
                    :on-change="handleChangeFinance" :on-remove="handleRemoveFinance" >
                    <el-button size="small" type="primary">选择文件</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="付款状态" prop="code">
                    <el-radio-group v-model="financeFrom.code" :disabled="financeFrom.codeShow === '1' ? true : false">
                        <el-radio label="已付款">已付款</el-radio>
                        <el-radio label="未付款">未付款</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelfFnance">取 消</el-button>
                <el-button type="primary" @click="submitFinance()">提 交</el-button>
            </span>
        </el-dialog>

        <!-- 提单号显示框 -->
         <el-dialog title="提示" :visible.sync="blNosAllDialog"  width="60%" :before-close="blNosClose" :close-on-click-modal="false">
            <span>{{ blNosValue }}</span>
        </el-dialog>
    </div>
</template>

<script>
import addFund from "@/view/addFund.vue";
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
import ExcelJS from 'exceljs'

export default {
    name: 'useFund',
    components: { addFund, },
    data() {
        return {
            paidStatusCheck:false, // 付款状态
            applyManList:[], // 人员列表
            rolePermission:localStorage.getItem('role'),
            searchText:'', // 提单号、金额查询
            id: '',//传值id
            customOption: [],//委托单位数据
            classOption: [],//货物分类数据
            queryParams: {
                beginTime: '', //创建时间(开始)
                endTime: '', //创建时间(结束)
                company: '',
                voucherNo: '',
                checkStatus: '0',
                note: '',//备注
                flag: 'FK',
                billNo:'',
                applyMan:'',
                paidStatus:'',
            },
            list: [],
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页显示的数据量
            total: 0, // 总数据量
            condition: '',
            // 开始时间限制范围
            approvalDialog:false, // 审批弹窗
            opinionDialog:false, // 审批意见弹窗
            opinionText:[], // 审批意见文字
            opinionFillDialog:false, // 填写审批意见弹窗
            opinionFill:{ // 填写审批意见
                instanceId:'',
                voucherId:'',
                comment:'',
            }, 
            approvalFrom:{
                voucherId:'',
                voucherName:'',
                flowKey:'',
                description:'',
                manager:'',
                file:[],
            }, // 审批信息
            flowableList:[], // 审批流程列表
            // staffOption:[], // 客户经理列表
            financeDialog:false, // 财务上传附件弹窗
            uploadFilesList: [], // 上传文件列表
            financeFrom:{
                voucherId:'',
                file:[],
                code:'',
                codeShow:'',
            },
            stepBar:{}, // 步骤条
            financeRules:{
                file: [
                    { required: true, message: '请上传文件', trigger: 'blur' }
                ],
            },
            // 上传附件url
            saveOneAttachmentURL:url1.saveOneAttachment,
            // startNoTime: {
            //     disabledDate(date) {
            //         // 可选当天以及当天之前的日期
            //         return date.getTime() > Date.now()
            //     }
            // },
            // 结束时间限制范围
            // endNoTime: {
            //     disabledDate(date) {
            //         // 可选当天以及当天之前的日期
            //         return date.getTime() > Date.now()
            //     }
            // },
            // 审批规则
            approvalRules:{
                flowKey:[
                    { required: true, message: '请选择流程名称', trigger: 'change' },
                ],
                // manager:[
                //     { required: true, message: '请选择客户经理', trigger: 'change' },
                // ],
            },
            blNosAllDialog:false, // 提单号对话框
            blNosValue:'',
        }
    },
    watch: {
        "queryParams.beginTime": {
            handler(val) {
                if (val) {
                    this.endNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime() - 8.64e7;
                            return time.getTime() < time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    // 当清空时，进行一些默认的设置或恢复初始的禁用规则
                    this.endNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        "queryParams.endTime": {
            handler(val) {
                if (val) {
                    this.startNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime()
                            return time.getTime() > time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    this.startNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
    },
    mounted() {
        this.getcustomList();
        this.getClassOption();
        this.getFlowableList();
        this.getApplyMan();
        // this.getStaffList();
        this.submit()

    },
    methods: {
        getApplyMan(){
            let URL = `${url.getOnDutyList}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.applyManList = res.data.data
                }
            })
        },
        searchList(){   
            if (!this.searchText.trim()) {
                return this.list;
            }
            // 将搜索文本统一转换为小写
            const searchLower = this.searchText.toLowerCase();
            return this.list.filter(row => {
                const keys = ["blNos", "amount"];
                return keys.some(key => {
                    let value = row[key];
                    if (value == null) return false;
                    // 将字段值转换为小写字符串进行比较
                    value = String(value).toLowerCase();
                    // 检查是否包含搜索文本（小写）
                    return value.includes(searchLower);
                })
            })
        },
        // 查询发起审批时的客户经理
        // getManagerByVoucherId(){
        //     let URL = `${url1.getManagerByVoucherId}/${this.approvalFrom.voucherId}`;
        //     req.get(URL).then(res => {
        //         if (res.data.code == 200) {
        //             this.approvalFrom.manager = res.data.data;
        //         } else {
        //             this.$message.error(res.data.message);
        //         }
        //     })
        // },
        // 发起审批流程
        approvalShow(data){
            if(localStorage.getItem('name') === data.createMan){
                this.approvalDialog = true
                this.approvalFrom.manager = localStorage.getItem('manager')
                this.approvalFrom.voucherId = data.id
                this.approvalFrom.voucherName = data.billNo
                // this.getManagerByVoucherId()
                // 查询当前审批是否有上传附件，有则显示出来
                let URL = `${url1.getFileListByVoucherId}/${this.approvalFrom.voucherId}`;
                req.get(URL).then(res => {
                    if (res.data.code === 200) {
                        this.uploadFilesList = res.data.data
                    }
                })
            }else{
                this.$message.error({
                    message: '非本人创建不可发起审批'
                });
            }
        },
        // 获取审批流程
        getFlowableList() {
            let URL = `${url1.getFlowableList}`;
            req.get(URL).then(res => {
                if (res.data.code == 200) {
                    this.flowableList = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        // 撤回审批
        withdraw(data){
            this.$confirm('是否确定撤回该审批?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url1.withdraw}/${data.processInstanceId}/${data.id}`;
                req.post(URL).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.data);
                        this.submit()
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {
                return        
            });
        },
        // //获得客户经理数据
        // getStaffList() {
        //     let URL = `${url.getUserByRole}/客户经理`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.staffOption = res.data.data;
        //         }
        //     })
        // },
        // 表单显示审批流程的备注
        changeFlowKey(data){
            const description = this.flowableList.filter(function(val) {
                return val.keyName === data;
            });
            this.approvalFrom.description = description[0].description
        },
        // 提交审批
        async submitApproval(){
            let arr = [];
            let that = this;
            await this.$refs.approvalFrom.validate((valid) => {
                if (valid) {
                    // 提交流程
                    let URL = `${url1.startProcess}/${this.approvalFrom.manager}/${this.approvalFrom.flowKey}/${this.approvalFrom.voucherId}`;
                    req.put(URL).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '提交成功!'
                            });
                            // 上传附件，循环单个上传
                            if(this.approvalFrom.file.length > 0){
                                let fileUrl = `${url1.saveOneAttachment}`
                                arr.push( new Promise(function(resolve, reject) { 
                                    for(let i = 0; i < that.approvalFrom.file.length; i++){
                                        const formData = new FormData();
                                        formData.append('file', that.approvalFrom.file[i].raw)
                                        formData.append('voucherId', that.approvalFrom.voucherId)
                                        req.post(fileUrl,formData).then(res => {
                                            if (res.data.code === 200) {
                                                resolve(res);
                                            }else{
                                                that.$message({
                                                    type: 'warning',
                                                    message: res.data.message
                                                });
                                                return false;
                                            }
                                        })
                                    }
                                }) )
                                Promise.all(arr).then(result => {
                                    this.approvalDialog = false
                                    this.approvalFrom = {}
                                    this.submit()
                                });
                            }else{
                                this.approvalDialog = false
                                this.approvalFrom = {}
                                this.submit()
                            }
                        }else{
                            this.$message({
                                type: 'warning',
                                message: res.data.message
                            });
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        // 取消审批
        cancelApproval(){
            this.approvalDialog = false
            this.approvalFrom = {
                voucherId:'',
                voucherName:'',
                flowKey:'',
                description:'',
                manager:'',
                file:[],
            }
            this.uploadFilesList = []
            this.$refs.approvalFrom.resetFields();
        },
        // 审批同意或驳回
        approvalPass(data){
            // 查询是否是本人待审
            let URL = `${url1.approvalJudgment}/${data.processInstanceId}/`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.opinionFillDialog = true
                    this.opinionFill.voucherId = data.id
                    this.opinionFill.instanceId = data.processInstanceId
                    this.opinionFill.comment = ''
                }
            })
        },
        // 同意审批
        agree(){
            let URL = `${url1.finishMyTask}/${this.opinionFill.instanceId}/${this.opinionFill.voucherId}?comment=${this.opinionFill.comment}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: res.data.data
                    });
                    this.opinionFillDialog = false
                    this.approveState('9');
                }
            })
        },
        // 驳回审批
        reject(){
            if(this.opinionFill.comment === '' || this.opinionFill.comment === ' '){
                this.$message.error('驳回请填写审批意见');
            }else{
                let URL = `${url1.rejected}/${this.opinionFill.instanceId}/${this.opinionFill.voucherId}?comment=${this.opinionFill.comment}`;
                req.post(URL).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: res.data.data
                        });
                        this.opinionFillDialog = false
                        this.approveState('9');
                    }
                })
            }
        },
        // 取消审批
        cancelapprove(){
            this.opinionFillDialog = false
            this.opinionFill.voucherId = ''
            this.opinionFill.instanceId = ''
            this.opinionFill.comment = ''
            this.$refs.approvalFrom.resetFields();
        },
        // 显示审批意见
        getCommentText(data){
            this.opinionDialog = true
            if( data.comment ){
                this.opinionText = data.comment.split(';')
            }else{
                this.opinionText = ['无']
            }
            // 步骤条
            if(data.processInstanceId){
                let URL = `${url1.getProcessStatusBy}/${data.processInstanceId}`;
                req.get(URL).then(res => {
                    if (res.data.code === 200) {
                        this.stepBar = res.data.data
                        this.stepBar.allNodes = this.stepBar.activeNodes? this.stepBar.completedNodes.concat(this.stepBar.activeNodes):this.stepBar.completedNodes
                        this.stepBar.createMan = data.createMan
                    }
                })
            }
        },
        // 关闭审批意见对话框
        closeOpinion(){
            this.opinionDialog = false; 
            this.opinionText = '';
            this.stepBar = {}
        },
        // 文件上传时勾子
        handleChange(file, fileList){
            this.approvalFrom.file = fileList;
        },
        // 移除文件勾子
        handleRemove(file, fileList){
            this.approvalFrom.file = fileList;
        },
        // 财务上传附件
        financeFiles(data){
            if(localStorage.getItem('role') === '财务'){
                this.financeDialog = true
                this.financeFrom.voucherId = data.id
                this.financeFrom.codeShow = data.financeStatus === '已付款' ? '1' : '0' // 1是已付款，不显示单选框，0是未付款，显示单选框
                this.financeFrom.code = '已付款'
            }else{
                this.$message.error({
                    message: '非财务人员不可发票登记'
                });
            }
            
        },
        // 文件上传时勾子
        handleChangeFinance(file, fileList){
            this.financeFrom.file = fileList;
        },
         // 移除文件勾子
        handleRemoveFinance(file, fileList){
            this.financeFrom.file = fileList;
        },
        // 财务文件提交，修改已付款状态
        submitFinance(){
            let arr = [];
            let that = this;
                // 上传附件，循环单个上传
                this.$refs.financeFrom.validate((valid) => {
                    if (valid) {
                         // 发票号提交
                         if(this.financeFrom.codeShow === '0' && this.financeFrom.code === '已付款') {// 未付款调接口改状态
                            let URL = `${url1.changeFKStatus}/${this.financeFrom.voucherId}`;
                            req.post(URL).then(res => {
                                if (res.data.code === 200) {

                                }else{
                                    that.$message({
                                        type: 'warning',
                                        message: res.data.message
                                    })
                                }
                            })
                         }
                        let fileUrl = `${url1.saveOneAttachment}`
                        arr.push( new Promise(function(resolve, reject) { 
                            for(let i = 0; i < that.financeFrom.file.length; i++){
                                const formData = new FormData();
                                formData.append('file', that.financeFrom.file[i].raw)
                                formData.append('voucherId', that.financeFrom.voucherId)
                                req.post(fileUrl,formData).then(res => {
                                    if (res.data.code === 200) {
                                        that.$message({
                                            type: 'success',
                                            message: res.data.message
                                        });
                                        resolve(res);
                                    }else{
                                        that.$message({
                                            type: 'warning',
                                            message: res.data.message
                                        })
                                        
                                    }
                                })
                            }
                        }) )
                        Promise.all(arr).then(result => {
                            this.cancelfFnance()
                            // that.financeDialog = false
                            // that.financeFrom = {}
                            that.submit()
                        });
                    }else{
                        return false;
                    }
                })
        },
        // 取消弹窗
        cancelfFnance(){
            this.financeDialog = false
            // this.financeFrom = {}
            this.$refs.financeFrom.resetFields();
        },
        deleteRow(row) {
            var that = this
            const value = localStorage.getItem('name');
            if (row.createMan !== value) {
                this.$message({
                    type: 'error',
                    message: '非本人创建，无法删除!'
                });
            } else {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let URL = `${url1.deleteById}/${row.id}`;
                    req.delete(URL).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            that.submit()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
        //区别状态
        getCheckStatusText(status) {
            switch (status) {
                case 0:
                    return '新增';
                case 1:
                    return '审核中';
                case 2:
                    return '审核完成';
                case 3:
                    return '驳回';
                default:
                    return '未知状态';
            }
        },
        handleClick(row) {
            this.id = row.id;
            this.$refs.addFund.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs.addFund.getFundDetail(row);
            });
            // this.$refs.addFund.getFundDetail();
        },
        rowStyle() {
            return "text-align:center";
        },
        search() {
            this.getData(1);

        },
        // 点击审核状态，直接调用接口
        approveState(data){
            // 待我审核
            if(data === '9'){
                let URL = `${url1.getMyTask}`;
                req.get(URL).then(res => {
                    if(res.data.code !== 200){
                        this.list = []
                        this.$message({
                            type: 'warning',
                            message: res.data.message
                        });
                    }else{
                        this.list = res.data.data.filter(function (item) {
                            return item.flag === 'FK';
                        });
                    }
                })
            }else{
                this.submit()
            }
            this.$nextTick(() => {
                this.$refs.tableId.doLayout();
            });
        },
        // 查询
        submit() {
            if(this.paidStatusCheck === false){
                // 没付款
                this.queryParams.paidStatus = ''
            }else{
                this.queryParams.paidStatus = '未付款'
            }
            // 当审核状态为待我审核时，不操作；状态为其他时调用接口
            if( this.queryParams.checkStatus !== '9' ){
                this.getData(1);
            }else{
                this.approveState('9')
            }
        },
        // 页数发生改变时
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData(this.currentPage);
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getData(this.currentPage)
        },
        getData(page) {
            this.currentPage = page;
            let URL = `${url1.getMyVoucherList}/${this.currentPage}/${this.pageSize}`;
            req.post(URL, this.queryParams).then(res => {
                if (res.data.code === 200) {
                    this.total = res.data.data.total;
                    this.list = res.data.data.records;
                }
            })
        },
        //添加
        add() {
            this.$refs.addFund.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs.addFund.getFundDetail(0);
            });
        },
        // 获取货物分类数据
        getClassOption() {
            let value = '货物分类';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.classOption = res.data.data.data;
                }
            })
        },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customOption = res.data.data;
                }
            })
        },
        // 文件下载
        downloadFile(data){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: data.annexUrl,
                    annexName: data.annexName
                }
            }
            window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
        },
        // 表格合计
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    // 第一列显示"合计"文本
                    sums[index] = '合计';
                    return;
                }
                // 只计算金额列(prop为'amount')
                if (column.property === 'amount') {
                const values = data.map(item => Number(item[column.property]));
                // 排除非数值
                const validValues = values.filter(value => !isNaN(value));
                if (validValues.length > 0) {
                    sums[index] = validValues.reduce((prev, curr) => {
                        return prev + curr;
                    }, 0);
                        // 添加单位（可选）
                    sums[index] = Number(sums[index]).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    } else {
                        sums[index] = ' ';
                    }
                } else {
                    // 其他列留空
                    sums[index] = '';
                }
            });
            return sums;
        },
        // 一键撤回到新建状态
        withdrawNew(data){
             this.$confirm('是否确认撤回？撤回后单据将变为新建状态', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let URL = `${url1.undoVoucher}/${data.id}`;
                    req.put(URL).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '撤回成功!'
                            });
                            this.submit()
                        }
                    })
                }).catch(() => {
                           
            });
        },
        // 点击复制所有提单号
        blNosAll(value){
            this.blNosAllDialog = true;
            this.blNosValue = value;
            // navigator.clipboard.writeText(value)
            // .then(() => window.alert('内容已添加到系统剪贴板'))
            // .catch(()=> window.alert('复制失败'));
        },
        blNosClose(){
            this.blNosAllDialog = false;
        },
        // 导出
        async exportExcel(){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            const columns = [
                { header: '单据编号', key: 'billNo', width: 20 },
                { header: '提单号', key: 'blNos', width: 20 },
                { header: '分单号', key: 'subNos', width: 20 },
                { header: '往来单位', key: 'company', width: 20 },
                { header: '发票号', key: 'voucherNo', width: 20 },
                { header: '金额', key: 'amount', width: 20 },
                { header: '币制', key: 'currency', width: 20 },
                { header: '审核状态', key: 'checkStatusText', width: 20 },
                { header: '付款状态', key: 'financeStatus', width: 20 },
                { header: '创建人', key: 'createMan', width: 20 },
                { header: '创建时间', key: 'createTime', width: 20 },
                { header: '备注', key: 'note', width: 20 },
            ];
              // 设置表头
            worksheet.columns = columns;
             // 添加数据行
            this.list.forEach(item => {
                item.checkStatusText = item.checkStatus === 0 ? '新建' : item.checkStatus === 1 ? '审核中' : item.checkStatus === 2 ? '审核完成' : item.checkStatus === 3 ? '审核驳回' : '待我审核';
                worksheet.addRow(item);
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime()}`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        getFormattedDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        },
    },
}
</script>

<style lang="css" scoped>
 ::v-deep body,
.container{
    width: 100%;
    height: calc(100vh - 82px);
    display: flex;
    flex-direction: column;
}
.seacher{
    padding-top: 10px;
    display: flex;
    justify-content: space-around;
    /* font-size: calc(16vw * 100 / 1920) */
}
.main_height{
    /* flex:1; */
    height: 660px;
}
.hoverStyle:hover {
    color: blue;
    /* 设置悬停时的字体颜色 */
    text-decoration: underline;
    /* 添加下划线 */
}
::v-deep .el-form-item {
    margin-bottom: 10px;
}
.upload-list{
    width: 48vw;
    min-width: 500px;
    display: flex;
}
.list-margin{
    margin: 0px 5px;
}
.ellipsis{
    display: -webkit-box;
    -webkit-line-clamp: 5; 
    -webkit-box-orient: vertical;
    overflow: hidden
}

</style>
